import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'datetime'
})
export class DateTime implements PipeTransform {

  constructor(private datePipe: DatePipe) {
  }
  transform(value: any, args?: any): any {
    return this.datePipe.transform(value, 'HH:mm:ss dd/MM/yyyy');
  }
}
